<template src="./project-list-type.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import { EventBus } from '@/router/bus'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import { hasAdminClaim, hasProjectListManageClaim } from '@/router/auth'
import FileSaver from 'file-saver'

export default {
  components: {
    ContextPage,
    Tabulator
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      data: [],
      listType: this.$route.params.listType,
      listName: this.$route.params.listName,
      dialog: false,
      loading: false,
      lists: [],
      selectedList: '',
      selectedApprovedList: '',
      projectsCount: 0,
      projectListTypes: {
        RATIONALIZATIONPROPOSAL: 1,
        RATIONALIZATION: 2,
        IDEA: 3,
        PROJECTIDENTIFICATION: 4,
        PREPAREDNESS: 5,
        CORRECTION: 6
      },
      phaseStatus: {
        ENTRY: 1,
        WAITINGCONFIRMATION: 2,
        WAITINGAPPROVAL: 3,
        APPROVED: 4,
        RATIONALIZATIONPROPOSAL: 5,
        WAITINGCOMMISSIONDECISION: 6,
        CORRECTION: 7,
        POSTPONED: 8,
        STOPPED: 9,
        ACCEPTEDRATIONALIZATION: 10,
        CANCELED: 11,
        WAITINGQUARTERCONFIRMATION: 12,
        WAITINGQUARTERAPPROVAL: 13,
        IDEA: 14,
        PROJECTIDENTIFICATION: 15,
        PREPAREDNESS: 16,
        CORRECTIONWAITINGLIST: 28
      },
      // projectPhases: {
      //   PREIMPLEMENTATION: 0,
      //   IDENTIFICATION: 1,
      //   PLAN: 2,
      //   REPORTING: 3,
      //   RATIONALIZATION: 4,
      //   CONCLUSION: 5,
      //   EFFECTS: 6
      // },
      projectPhases: {
        IDEA: 0,
        PROJECTIDENTIFICATION: 1,
        PREPAREDNESS: 2,
        IMPORTANT: 3,
        PLAN: 4,
        REPORTING: 5,
        RATIONALIZATION: 6,
        CONCLUSION: 7,
        EFFECTS: 8,
        PREIMPLEMENTATION: 9,
        IDENTIFICATION: 10,
        CORRECTION: 11
      },
      projectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      tabulatorOptions: {
        ajaxResponse: (url, params, response) => {
          this.projectsCount = response.payload.length
          this.selectedApprovedList = this.isAnyProjectCommissionApproved(response.payload)
          return this.ajaxResponse(url, params, response)
        },
        columns: [
          {
            title: '',
            field: 'id',
            visible: false,
            headerSort: false
          },
          {
            title: this.$t('projects.officalProposerOrganization'),
            field: 'organizationName',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('projects.number'),
            field: 'number',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          // {
          //   title: this.$t('projects.code'),
          //   field: 'code',
          //   headerSort: true,
          //   headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
          //   headerFilter: this.vTextFieldFilter,
          //   headerFilterLiveFilter: false,
          //   hozAlign: 'center'
          // },
          {
            title: this.$t('projects.name'),
            field: 'nameFormJson',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('projects.createdDate'),
            hozAlign: 'center',
            field: 'createdDate',
            sorter: 'date',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('general.undefined')
            },
            headerFilter: this.vDateRange,
            headerFilterParams: { isRange: true },
            headerFilterLiveFilter: false
          },
          {
            title: this.$t('projects.phase'),
            field: 'phase',
            headerSort: false,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            formatter: (cell) => {
              const phasePreparation = [0, 1, 2, 3]
              const phaseFinished = [7, 8]
              const phaseValue = cell.getValue()
              if (phaseFinished.includes(phaseValue)) {
                return this.$t('projects.phaseFinished')
              } else if (phasePreparation.includes(phaseValue)) {
                return this.$t('projects.phasePreparation')
              }
              return this.$t('projects.phaseRealization')
            }
          },
          {
            title: this.$t('projects.stage'),
            hozAlign: 'center',
            field: 'phase',
            tooltip: (cell) => {
              const phase = cell.getValue()
              return this.$t('projects.stages.' + phase)
            },
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            formatter: (cell) => {
              const phase = cell.getValue()
              return this.$t('projects.stages.' + phase)
            },
            headerFilterEmptyCheck: (value) => {
              return value === '0'
            },
            headerFilterParams: {
              values: [
                {
                  text: this.$t('projects.stages.0'),
                  value: 0
                },
                {
                  text: this.$t('projects.stages.1'),
                  value: 1
                },
                {
                  text: this.$t('projects.stages.2'),
                  value: 2
                },
                {
                  text: this.$t('projects.stages.3'),
                  value: 3
                },
                {
                  text: this.$t('projects.stages.4'),
                  value: 4
                },
                {
                  text: this.$t('projects.stages.5'),
                  value: 5
                },
                {
                  text: this.$t('projects.stages.6'),
                  value: 6
                },
                {
                  text: this.$t('projects.stages.7'),
                  value: 7
                },
                {
                  text: this.$t('projects.stages.8'),
                  value: 8
                }
              ]
            }
          },
          {
            title: this.$t('projects.phаseStatus'),
            hozAlign: 'center',
            field: 'phaseStatus',
            tooltip: (cell) => {
              const status = cell.getValue()
              return this.$t('projects.phaseStatuses.' + status)
            },
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            formatter: (cell) => {
              const status = cell.getValue()
              if (status === 4) {
                return this.successLabel(this.$t('projects.phaseStatuses.' + status))
              } else if (status === 9 || status === 11) {
                return this.errorLabel(this.$t('projects.phaseStatuses.' + status))
              }
              return this.infoLabel(this.$t('projects.phaseStatuses.' + status))
            },
            headerFilterEmptyCheck: (value) => {
              return value === '0'
            },
            headerFilterParams: {
              values: [
                {
                  text: this.$t('projects.phaseStatuses.1'),
                  value: 1
                },
                {
                  text: this.$t('projects.phaseStatuses.2'),
                  value: 2
                },
                {
                  text: this.$t('projects.phaseStatuses.3'),
                  value: 3
                },
                {
                  text: this.$t('projects.phaseStatuses.4'),
                  value: 4
                },
                {
                  text: this.$t('projects.phaseStatuses.5'),
                  value: 5
                },
                {
                  text: this.$t('projects.phaseStatuses.6'),
                  value: 6
                },
                {
                  text: this.$t('projects.phaseStatuses.7'),
                  value: 7
                },
                {
                  text: this.$t('projects.phaseStatuses.8'),
                  value: 8
                },
                {
                  text: this.$t('projects.phaseStatuses.9'),
                  value: 9
                },
                {
                  text: this.$t('projects.phaseStatuses.10'),
                  value: 10
                },
                {
                  text: this.$t('projects.phaseStatuses.11'),
                  value: 11
                },
                {
                  text: this.$t('projects.phaseStatuses.12'),
                  value: 12
                },
                {
                  text: this.$t('projects.phaseStatuses.13'),
                  value: 13
                }
              ]
            }
          }
        ],
        rowClick: (e, row) => {
          const projectURL = '/projects/' + row.getData().code + '/details'
          this.handleRowClickNavigation(e, projectURL)
        }
      }
    }
  },
  computed: {
    canCreateProjectList () {
      return hasAdminClaim() || hasProjectListManageClaim()
    },
    createListLabel () {
      switch (Number(this.listType)) {
        case this.projectListTypes.RATIONALIZATIONPROPOSAL:
          return this.$t('projects.createRationalizationList')
        case this.projectListTypes.RATIONALIZATION:
          return this.$t('projects.createProposalRationalizationList')
        case this.projectListTypes.IDEA:
          return this.$t('projects.createIdeaList')
        case this.projectListTypes.PROJECTIDENTIFICATION:
          return this.$t('projects.createProjectIdentificationList')
        case this.projectListTypes.PREPAREDNESS:
          return this.$t('projects.createPreparednessList')
        case this.projectListTypes.CORRECTION:
          return this.$t('projects.createCorrectionList')
        default:
          return ''
      }
    }
  },
  mounted () {
    this.setupPage()
  },
  methods: {
    setupPage () {
      if (!this.listName) {
        this.getProjects()
      }
      this.getLists()
    },
    isAnyProjectCommissionApproved (items) {
      if (Number(this.listType) !== 1 && Number(this.listType) !== 2 && Number(this.listType) !== 6) {
        return items.some(x => x.commissionApproved === true && !x.important)
      }
      return false
    },
    getFilter () {
      switch (Number(this.listType)) {
        case this.projectListTypes.RATIONALIZATIONPROPOSAL:
          return '?filter[phaseStatus]=' + this.phaseStatus.RATIONALIZATIONPROPOSAL + '&filter[phase]=' + this.projectPhases.REPORTING + '&filter[status]=' + this.projectStatus.PENDING
        case this.projectListTypes.RATIONALIZATION:
          return '?filter[phaseStatus]=' + this.phaseStatus.APPROVED + '&filter[phase]=' + this.projectPhases.RATIONALIZATION + '&filter[status]=' + this.projectStatus.PENDING
        case this.projectListTypes.IDEA:
          return '?filter[phaseStatus]=' + this.phaseStatus.IDEA + ',' + this.phaseStatus.WAITINGCOMMISSIONDECISION + '&filter[phase]=' + this.projectPhases.IDEA + '&filter[status]=' + this.projectStatus.PENDING + '&filter[lists]=' + this.projectListTypes.IDEA
        case this.projectListTypes.PROJECTIDENTIFICATION:
          return '?filter[phaseStatus]=' + this.phaseStatus.PROJECTIDENTIFICATION + ',' + this.phaseStatus.WAITINGCOMMISSIONDECISION + '&filter[phase]=' + this.projectPhases.PROJECTIDENTIFICATION + '&filter[status]=' + this.projectStatus.PENDING + '&filter[lists]=' + this.projectListTypes.PROJECTIDENTIFICATION
        case this.projectListTypes.PREPAREDNESS:
          return '?filter[phaseStatus]=' + this.phaseStatus.PREPAREDNESS + ',' + this.phaseStatus.WAITINGCOMMISSIONDECISION + '&filter[phase]=' + this.projectPhases.PREPAREDNESS + '&filter[status]=' + this.projectStatus.PENDING + '&filter[lists]=' + this.projectListTypes.PREPAREDNESS
        case this.projectListTypes.CORRECTION:
          return '?filter[phaseStatus]=' + this.phaseStatus.CORRECTIONWAITINGLIST + ',' + this.phaseStatus.WAITINGCOMMISSIONDECISION + '&filter[phase]=' + this.projectPhases.CORRECTION + '&filter[status]=' + this.projectStatus.PENDING + '&filter[lists]=' + this.projectListTypes.CORRECTION
      }
    },
    getProjects () {
      this.tabulatorInstance.setData(Vue.$config.api_root + '/' + Vue.$apiConfig.pagedProjectsGet + '/pending' + this.getFilter())
    },
    getListProjects () {
      this.tabulatorInstance.setData(Vue.$config.api_root + '/' + Vue.$apiConfig.projectListProjectsGet.replace('{projectTypeList}', this.listType) + '/' + this.selectedList)
    },
    send () {
      this.showLoader(true)
      this.loading = true
      const url = Vue.$apiConfig.createProjectListPost.replace('{projectTypeList}', this.listType) + '?sort_by=lastChangeDate&sort_desc=asc'
      this.$http.post(url).then(
        response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('projects.sendListSuccessful'),
            errors: []
          })
          this.setupPage()
          this.showLoader(false)
          this.loading = false
          this.dialog = false
        },
        error => {
          this.formatErrorResponse(error)
          this.showLoader(false)
          this.loading = false
          this.dialog = false
        })
    },
    getLists () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.projectListsGet.replace('{projectTypeList}', this.listType)).then(
        response => {
          const lists = [{ name: '' }]
          this.lists = lists.concat(response.data.payload)
          if (this.listName) {
            this.selectedList = this.listName
            this.changeList()
          }
          this.showLoader(false)
        },
        error => {
          this.formatErrorResponse(error)
          this.showLoader(false)
        })
    },
    changeList () {
      if (this.selectedList !== '') {
        this.getListProjects()
        history.pushState({}, null, '/project-lists/' + this.listType + '/' + this.selectedList)
      } else {
        this.getProjects()
        history.pushState({}, null, '/project-lists/' + this.listType)
      }
    },
    downloadApprovedList () {
      this.showLoader(true)
      this.loading = true
      this.$http.get(Vue.$apiConfig.projectApprovedListDocumentGet.replace('{projectTypeList}', this.listType).replace('{projectListName}', this.selectedList), { responseType: 'blob' })
        .then(
          response => {
            const blob = new Blob([response.data], { type: 'application/zip' })
            FileSaver.saveAs(blob, this.selectedList + '.zip')
            this.showLoader(false)
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.loading = false
          }
        )
    },
    download () {
      this.showLoader(true)
      this.loading = true
      this.$http.get(Vue.$apiConfig.projectListDocumentGet.replace('{projectTypeList}', this.listType).replace('{projectListName}', this.selectedList), { responseType: 'blob' })
        .then(
          response => {
            const blob = new Blob([response.data], { type: 'application/zip' })
            FileSaver.saveAs(blob, this.selectedList + '.zip')
            this.showLoader(false)
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.loading = false
          }
        )
    },
    showLoader (loader) {
      EventBus.$emit('projectDocumentsLoader', loader)
    }
  }
}
</script>
